import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage2 from '../../../../assets/images/work/sn-cas/CAS_Slider_2.webp';
import projectImage3 from '../../../../assets/images/work/sn-cas/CAS_Slider_3.webp';
import projectImage4 from '../../../../assets/images/work/sn-cas/CAS_Slider_4.webp';
import projectImage5 from '../../../../assets/images/work/sn-cas/CAS_Slider_5.webp';
import projectImage6 from '../../../../assets/images/work/sn-cas/CAS_Slider_6.webp';
import projectImage7 from '../../../../assets/images/work/sn-cas/CAS_Slider_7.webp';
import projectImage8 from '../../../../assets/images/work/sn-cas/CAS_Slider_8.webp';

import Data_SNCAS from './Data_SNCAS';

function Work_SNCAS() {
    const canonical = 'https://studio.norcat.org/OurWork/sn-cas';
    const title = 'Climate Action Show | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, The Climate Action Show is an interactive installation that helps young visitors explore climate action, systems thinking, and real-world change through hands-on engagement.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage2}`}
                ogImageAlt="Preview of the Climate Action Show interactive installation project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage2}`}
                twitterImageAlt="Preview of the Climate Action Show interactive installation project"
            />
            <DetailedHeader
                heading="Empowering the Next Generation of Change Agents"
                client="Science North"
                service="Installation"
                date="2022-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=GGCqzm8CMw4"
                images={[
                    {
                        image: projectImage2,
                        alt: 'Climate Action Show project screenshot 1',
                    },
                    {
                        image: projectImage3,
                        alt: 'Climate Action Show project screenshot 2',
                    },
                    {
                        image: projectImage4,
                        alt: 'Climate Action Show project screenshot 3',
                    },
                    {
                        image: projectImage5,
                        alt: 'Climate Action Show project screenshot 4',
                    },
                    {
                        image: projectImage6,
                        alt: 'Climate Action Show project screenshot 5',
                    },
                    {
                        image: projectImage7,
                        alt: 'Climate Action Show project screenshot 6',
                    },
                    {
                        image: projectImage8,
                        alt: 'Climate Action Show project screenshot 7',
                    },
                ]}
            />

            {Data_SNCAS.content}
        </>
    );
}

export default Work_SNCAS;
